import * as $ from 'jquery';

export default (function () {

    function search_integraion(){
        var prov_value = $("#prooveedor_id").val();
        $("#integracion_id > option").each(function () {
            if ($(this).attr('proveedor_id') == prov_value || $(this).val() == "") {
                $(this).removeAttr("disabled");
            } else {
                $(this).attr("disabled", "disabled");
            }
        });
        $("#integracion_id").val("").change();
    }

    $("#prooveedor_id").change(function () {
        search_integraion();
    })

    function search_integraion2(){
        var prov_value = $("#prooveedor_id2").val();
        $("#integracion_id2 > option").each(function () {
            if ($(this).attr('proveedor_id') == prov_value || $(this).val() == "") {
                $(this).removeAttr("disabled");
            } else {
                $(this).attr("disabled", "disabled");
            }
        });
        $("#integracion_id2").val("").change();
    }

    $("#prooveedor_id2").change(function () {
        search_integraion2();
    })

    $("a.alert_link").click(function(){
        var attr_link =  $(this).attr('show-url');
        alert(attr_link);
    });
    
}());
